import React from 'react';
import quoteIcon from '../../assets/quote.png';
import { TDHOutlineLogo } from '@td-client-frontend/icons';

const data = {
  news: [
    {
      title: 'Teladoc Health Ranks First',
      description: 'Teladoc Health Ranks First in Consumer Satisfaction by J.D. Power 2021 Telehealth Study',
      image: 'jd-power-awards-2021.png',
      to: 'https://teladochealth.com/newsroom/press/release/teladoc-health-ranks-first-in-consumer-satisfaction-by-j-d-power-2021/'
    },
    {
      title: 'Teladoc Health Primary Care',
      description: 'Teladoc Health Reimagines Primary Care with Primary360',
      image: 'tdh-primary-360.png',
      to: 'https://teladochealth.com/newsroom/press/release/teladoc-health-reimagines-primary-care-with-primary360/'
    },
    {
      title: 'Teladoc Health Whole Person Care',
      description:
        'Teladoc Health Improves Access to Whole-Person Care Through an Expanded Partnership with National Labor Alliance',
      image: 'tdh-whole-person-care.png',
      to: 'https://teladochealth.com/newsroom/press/release/teladoc-health-improves-access-to-whole-person-care-through-an-expanded/'
    }
  ],
  testimonials: [
    {
      quote:
        'I had no fear at all because of the advice I had received in my report and the expert surgeon who reviewed my case. [After surgery], I’m now 95% repaired. It was life-changing.',
      name: 'Kenneth',
      about: 'Expert Medical Services member'
    },
    {
      quote:
        'My doctor could not have been more attentive, supportive, encouraging, interested and knowledgeable. I had her full attention during our nearly 45 minutes together.',
      name: 'Kiana',
      about: 'Primary Care member'
    },
    {
      quote:
        'Thanks to Livongo, I have a system that gives me the information and support that I need to stay on track. Your product can really change someone’s life!',
      name: 'Curt',
      about: 'Diabetes Management & Hypertension Management member'
    }
  ]
};

export default function Dashboard() {
  const { news, testimonials } = data;
  return (
    <div className="bg-gray-background">
      <div className="container mx-auto px-4" style={{ maxWidth: '955px' }}>
        <section
          className="flex-1 relative text-white mt-8 p-4 rounded-lg"
          style={{
            background: 'linear-gradient(45deg,#332364,#3E2F75,#504393,#584B9F)'
          }}
        >
          <div className="container relative mx-auto flex flex-col">
            <div className="flex flex-row justify-evenly ml-14">
              <h3 className="sm:text-5xl text-left whitespace-nowrap">
                The <b>global leader</b> in virtual care
              </h3>
            </div>
            <div className="flex flex-row justify-evenly">
              <div>
                <p className="text-7xl text-yellow-10">+</p>
                <p className="sm:text-5xl font-bold">12,000</p>
                <p className="whitespace-nowrap">clients</p>
              </div>
              <div>
                <p className="text-7xl text-yellow-10">+</p>
                <p className="sm:text-5xl font-bold">4,400</p>
                <p className="whitespace-nowrap">employees</p>
              </div>
              <div>
                <p className="text-7xl text-yellow-10">+</p>
                <p className="sm:text-5xl font-bold">51.5M</p>
                <p className="whitespace-nowrap">U.S. paid members</p>
              </div>
              <div>
                <p className="text-7xl text-yellow-10">+</p>
                <p className="sm:text-5xl font-bold">10.5M</p>
                <p className="whitespace-nowrap">medical visits delivered in 2020</p>
              </div>
            </div>
          </div>
          <TDHOutlineLogo
            className="absolute top-0 right-0 left-1/2 h-full opacity-10"
            style={{ filter: 'invert(1)' }}
          />
        </section>
        <section className="py-5">
          <h3 className="pb-4 whitespace-nowrap mx-auto">Teladoc Health in the news</h3>
          <div className="flex mx-auto">
            {news &&
              news.map((card) => {
                const { image, title, to, description } = card;
                return (
                  <div key={title} className="flex-1 flex-col bg-white border-solid border-1 border-gray-20 w-80">
                    <img className="object-cover w-80" src={require(`../../assets/${image}`).default} alt="" />
                    <div className="m-5">
                      <h3>
                        <a
                          className="text-primary-500"
                          href={to}
                          title={title}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {title}
                        </a>
                      </h3>
                      <p className="text-lg text-gray-55">{description}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
        <section className="pb-24">
          <h3 className="pb-4">Testimonials</h3>
          <div className="flex space-x-6">
            {testimonials &&
              testimonials.map((testimonial) => {
                const { quote, name, about } = testimonial;
                return (
                  <div key={name} className="flex-1 flex-col bg-white p-8 shadow-lg">
                    <img className="mx-auto" src={quoteIcon} alt="quotation" />
                    <p className="text-lg my-6 text-gray-55">{quote}</p>
                    <p className="text-2xl mt-auto">{name}</p>
                    <p className="text-sm text-gray-55">{about}</p>
                  </div>
                );
              })}
          </div>
        </section>
      </div>
    </div>
  );
}
